import Fade from "@mui/material/Fade"
import CircularProgress from "@mui/material/CircularProgress"
import type { CSSProperties } from "react"

type Props = {
  inAction?: boolean
  style?: CSSProperties
  delay?: string
}

const Loading = ({ inAction = true, style, delay = "200ms" }: Props) => {
  const containerStyle: CSSProperties = {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    zIndex: 1,
  }
  const fadeStyle: CSSProperties = {
    transitionDelay: inAction ? delay : "0ms",
  }

  return (
    <div style={{ ...containerStyle, ...(style || {}) }}>
      <Fade in={inAction} unmountOnExit style={fadeStyle}>
        <CircularProgress />
      </Fade>
    </div>
  )
}

export default Loading
